import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import { Box, Typography } from "@mui/material";
import React from "react";
import { IMessageDataVoice } from "@home-health-notify/domain";

const AudioThumb = ({ voiceMessage }: { voiceMessage: IMessageDataVoice }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <KeyboardVoiceIcon color="primary" fontSize="large" />
      <Typography variant="caption">{voiceMessage.duration}</Typography>
    </Box>
  );
};

export default AudioThumb;
